module.exports = __webpack_public_path__ + "static/fonts/SCDream9.30b6b48.woff";